export default (arr) =>
  arr[0] * 50000 +
  arr[1] * 20000 +
  arr[2] * 10000 +
  arr[3] * 5000 +
  arr[4] * 2000 +
  arr[5] * 1000 +
  arr[6] * 500 +
  arr[7] * 200 +
  arr[8] * 100 +
  arr[9] * 50 +
  arr[10] * 20 +
  arr[11] * 10 +
  arr[12] * 5 +
  arr[13] * 2 +
  arr[14] * 1;
